import { useMemo } from 'react';

import { getEnvironment, Version as SharedVersion } from '@eduzz/shared';

import { version } from '../package.json';

const PACKAGE_NAME = '@eduzz/ui-antd-theme';

const Version = () => {
  const currentVersion = useMemo(() => {
    if (getEnvironment() === 'prod') {
      return version;
    }

    const searchParamVersion = new URLSearchParams(window.location.search).get('version');
    return searchParamVersion || version;
  }, []);

  const showVersion = useMemo(() => new URLSearchParams(window.location.search).get('showVersion') === 'true', []);

  const enableNag = useMemo(() => {
    if (showVersion) {
      return true;
    }

    return getEnvironment() !== 'prod';
  }, [showVersion]);

  return (
    <SharedVersion
      currentVersion={currentVersion}
      packageName={PACKAGE_NAME}
      enableNag={enableNag}
      showVersion={showVersion}
    />
  );
};

export default Version;
